import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

interface IHttpResponse {
  error_code: number;
  error_msg: string;
  data: any;
}

interface IGetHouseGroupList {
  format?: string;
}

interface ISetAutoReplyStatus {
  status: number;
}

interface IGetAutoReplyList {
  page: number;
  page_size: number;
  reply_thirdparty?: string;
  create_operator_id?: number;
  keyword?: string;
  house_ids?: string;
  message_type?: number;
  sort?: 'counter^desc' | 'counter^asc';
}

interface ISetAutoReplyContentStatus {
  id: number;
  status: number;
}

interface IEditAutoReplyRecord {
  id?: number;
  message_type: number;
  keyword_type: number | null;
  keyword: string | null;
  reply_thirdparties: Array<number> | null;
  start_time: string | null;
  end_time: string | null;
  link_type: number | null;
  link_ids: any | null;
  content: string;
  quick_message_id: number | null;
}

interface IGetQuickMessageList {
  quick_message_group_ids?: Array<number>;
  create_user_ids?: Array<number>;
  only_self?: number;
  page?: number;
  page_size?: number;
}

interface IPostId {
  id: number;
}

interface IAddQuickMessageGroup {
  name: string;
  scope?: number;
}

interface IAddQuickMessage {
  quick_message_group_id: number;
  title?: string;
  content: string;
  scope?: number;
}

interface IUpdateQuickMessage {
  id?: number;
  quick_message_group_id: number;
  title?: string;
  content: string;
  scope: number;
}

interface IEditQuickMessage {
  id: number;
  name: string;
  scope: number;
}


// 自动回复
const GET_SETTINGS_API = '/api/house_status_setting/get';
const GET_HOUSE_GROUP_LIST_API = '/api/reservation/house_group_list';
const GET_AUTO_REPLY_DETAIL_API = 'api/auto_reply/detail';
const SET_AUTO_REPLY_STATUS_API = 'api/auto_reply/set';
const GET_AUTO_REPLY_LIST_API = 'api/auto_reply/content_list';
const SET_AUTO_REPLY_CONTENT_STATUS_API = 'api/auto_reply/content_set_status';
const SAVE_AUTO_REPLY_CONTENT_API = 'api/auto_reply/content_save';
const DELETE_AUTO_REPLY_CONTENTE_API = 'api/auto_reply/content_delete';
const GET_AUTO_REPLY_CONTENT_CREATE_OPERATOR_LIST_API = 'api/auto_reply/content_create_operator_list';
const GET_CHAT_THIRDPARTY = 'api/chat/had_thirdparty';

// 快捷消息
const GET_QUICK_MESSAGE_GROUP_LIST_API = 'api/quick_message/group_list';
const GET_QUICK_MESSAGE_CREATOR_LIST_API = 'api/quick_message/create_user_list';
const QUICK_MSG_DETAIL_API = 'api/quick_message/detail';
const GET_QUICK_MESSAGE_LIST_API = 'api/quick_message/list';
const UPDATE_QUICK_MESSAGE_ACTIVE_API = 'api/quick_message/update_active';
const DELETE_QUICK_MESSAGE_API = 'api/quick_message/remove';
const ADD_QUICK_MESSAGE_GROUP_API = 'api/quick_message/group_add';
const REMOVE_QUICK_MESSAGE_GROUP_API = 'api/quick_message/group_remove';
const ADD_QUCIK_MESSAGE_API = 'api/quick_message/add';
const UPDATE_QUICK_MESSAGE_API = 'api/quick_message/update';
const UPDATE_QUICK_MESSAGE_GROUP_API = 'api/quick_message/group_update';

@Injectable({
  providedIn: 'root'
})
export class DialogueSettingService {

  constructor(
    private http: HttpClient,
  ) { }

  /** 获取房态配置 */
  getSettings() {
    const query = new HttpParams();
    return this.http.get(
      GET_SETTINGS_API, { params: query }
    ) as Observable<IHttpResponse>;
  }

  /** 订单查询房源分组和房源列表 */
  getHouseGroupList(params: IGetHouseGroupList) {
    const query = new HttpParams().append('format', `${params.format}`);
    return this.http.get(GET_HOUSE_GROUP_LIST_API, {
      params: query
    }) as Observable<IHttpResponse>;
  }

  /** 获取全局自动回复详情 */
  getAutoReplyDetail() {
    const query = new HttpParams();
    return this.http.get(
      GET_AUTO_REPLY_DETAIL_API, { params: query }
    ) as Observable<IHttpResponse>;
  }

  /** 全局自动回复设置 */
  setAutoReplyStatus(params: ISetAutoReplyStatus) {
    return this.http.post(
      SET_AUTO_REPLY_STATUS_API, params
    ) as Observable<IHttpResponse>;
  }

  /** 自动回复内容列表 */
  getAutoReplyList(params: IGetAutoReplyList) {
    const query = new HttpParams()
      .append('page', `${params.page}`)
      .append('page_size', `${params.page_size}`)
      .append('reply_thirdparty', `${params.reply_thirdparty}`)
      .append('create_operator_id', `${params.create_operator_id}`)
      .append('keyword', `${params.keyword}`)
      .append('house_ids', `${params.house_ids}`)
      .append('message_type', `${params.message_type}`)
      .append('sort', `${params.sort}`);
    return this.http.get(
      GET_AUTO_REPLY_LIST_API, { params: query }
    ) as Observable<IHttpResponse>;
  }

  /** 设置自动回复内容开启或关闭 */
  setAutoReplyContentStatus(params: ISetAutoReplyContentStatus) {
    return this.http.post(
      SET_AUTO_REPLY_CONTENT_STATUS_API, params
    ) as Observable<IHttpResponse>;
  }

  /** 编辑自动回复记录 */
  saveAutoReplyContent(params: IEditAutoReplyRecord) {
    return this.http.post(
      SAVE_AUTO_REPLY_CONTENT_API, params
    ) as Observable<IHttpResponse>;
  }

  /** 删除自动回复内容记录 */
  deleteAutoReplyContent(params: IPostId) {
    return this.http.post(
      DELETE_AUTO_REPLY_CONTENTE_API, params
    ) as Observable<IHttpResponse>;
  }

  /** 自动回复内容创建人列表 */
  getAutoReplyContentCreateOperatorList() {
    const query = new HttpParams();
    return this.http.get(
      GET_AUTO_REPLY_CONTENT_CREATE_OPERATOR_LIST_API, {
      params: query
    }
    ) as Observable<IHttpResponse>;
  }

  fetchQucikMessageDetail (params) {
    const query = new HttpParams({
      fromObject: params
    });

    return this.http.get(QUICK_MSG_DETAIL_API, { params: query }) as Observable<any>;
  }

  /** 快捷消息分组列表 */
  getQuickMessageGroupList() {
    const query = new HttpParams();
    return this.http.get(GET_QUICK_MESSAGE_GROUP_LIST_API, {
      params: query
    }) as Observable<IHttpResponse>;
  }

  /** 快捷消息创建人列表 */
  getQuickMessageCreatorList() {
    const query = new HttpParams();
    return this.http.get(GET_QUICK_MESSAGE_CREATOR_LIST_API, {
      params: query
    }) as Observable<IHttpResponse>;
  }

  /** 获取快捷消息列表 */
  getQuickMessageList(params: IGetQuickMessageList) {
    const query = new HttpParams()
      .append('quick_message_group_ids', `${params.quick_message_group_ids}`)
      .append('create_user_ids', `${params.create_user_ids}`)
      .append('only_self', `${params.only_self}`)
      .append('page', `${params.page}`)
      .append('page_size', `${params.page_size}`);
    return this.http.get(GET_QUICK_MESSAGE_LIST_API, {
      params: query
    }) as Observable<IHttpResponse>;
  }

  /** 更新快捷回复启用情况 */
  updateQuickMessageStatus(params: IPostId) {
    return this.http.post(
      UPDATE_QUICK_MESSAGE_ACTIVE_API, params
    ) as Observable<IHttpResponse>;
  }

  /** 删除快捷消息 */
  deleteQuickMessage(params: IPostId) {
    return this.http.post(
      DELETE_QUICK_MESSAGE_API, params
    ) as Observable<IHttpResponse>;
  }

  /** 添加快捷消息分组 */
  addQuickMessageGroup(params: IAddQuickMessageGroup) {
    return this.http.post(
      ADD_QUICK_MESSAGE_GROUP_API, params
    ) as Observable<IHttpResponse>;
  }

  /** 删除快捷消息分组 */
  removeQuickMessageGroup(params: IPostId) {
    return this.http.post(
      REMOVE_QUICK_MESSAGE_GROUP_API, params
    ) as Observable<IHttpResponse>;
  }

  /** 添加快捷消息 */
  addQuickMessages(params: IAddQuickMessage) {
    return this.http.post(
      ADD_QUCIK_MESSAGE_API, params
    ) as Observable<IHttpResponse>;
  }

  /** 编辑快捷消息 */
  editQuickMessage(params: IUpdateQuickMessage) {
    return this.http.post(
      UPDATE_QUICK_MESSAGE_API, params
    ) as Observable<IHttpResponse>;
  }

  /** 获取聊天渠道列表 */
  getChatChannels() {
    const query = new HttpParams();
    return this.http.get(GET_CHAT_THIRDPARTY,
      { params: query }
    ) as Observable<IHttpResponse>;
  }

  /** 编辑快捷消息分组 */
  updateQuickMessageGroup(params: IEditQuickMessage) {
    return this.http.post(
      UPDATE_QUICK_MESSAGE_GROUP_API, params
    ) as Observable<IHttpResponse>;
  }
}
